module.exports = __webpack_public_path__ + "img/HC1037-01.3c894765.jpg";